export default {
	en: {
		filter_category: 'Filter by category:',
		all: 'ALL',

	},
	es: {
		filter_category: 'Filtrar por categoría:',
		all: 'TODOS',
	}
}